export const QUERY_KEYS = {
  // Home related query keys
  GET_CHANNELS: 'getChannels',
  GET_HOME_METRIC_CARDS_DATA: 'getHomeMetricCardsData',
  GET_TOTAL_SALES: 'getTotalSales',
  GET_NET_SALES: 'getNetSales',
  GET_TERMINALS_REVENUE: 'getTerminalsRevenue',
  GET_FAILURE_REASONS: 'getFailureReasons',
  GET_PERFORMANCE_HIGHLIGHTS: 'getPerformanceHighlights',
  GET_METHODS_USAGE: 'getMethodsUsage',
  GET_ONBOARDING_BANNER: 'getOnboardingBanner',
  // Balances related query keys
  GET_TRANSFERS: 'getTransfers',
  GET_TRANSFERS_FILTERS: 'getTransfersFilters',
  GET_SINGLE_TRANSFER_DETAILS: 'getSingleTransferDetails',
  GET_SINGLE_TRANSFER_TRANSACTIONS: 'getSingleTransferTransactions',
  GET_BALANCE_DETAILS: 'getBalanceDetails',
  GET_BALANCE_REPORTS: 'getBalanceReports',
  GET_RECENT_TRANSFERS: 'getRecentTransfers',
  GET_SETTLEMENT_MODE_DETAILS: 'getSettlementModeDetails',
  CHANGE_SETTLEMENT_MODE: 'changeSettlementMode',
  GET_INSTANT_SETTLEMENT_BALANCE: 'getInstantSettlementBalance',
  GET_WITHDRAW_BALANCE: 'getWithdrawBalance',
  GET_WITHDRAW_FEES: 'getWithdrawFees',
  SUBMIT_WITHDRAW: 'submitWithdraw',
  GET_TRANSFERS_CARDS_TABS: 'getTransfersCardsTabs',
  GET_INSTANT_SETTLEMENT_FEES: 'getInstantSettlementFees',
  GET_BANK_ACCOUNT_DETAILS: 'getBankAccountDetails',
  // Transactions related query keys
  GET_TRANSACTIONS: 'getTransactions',
  GET_TRANSACTIONS_FILTERS: 'getTransactionsFilters',
  GET_SINGLE_TRANSACTION: 'getSingleTransaction',
  GET_SINGLE_TRANSACTION_HEADER_INFO: 'getSingleTransactionHeaderInfo',
  GET_SINGLE_TRANSACTION_DETAILS: 'getSingleTransactionDetails',
  GET_TRANSACTIONS_METRIC_CARDS_DATA: 'getTransactionsMetricCardsData',
  GET_PAYME_TRANSACTIONS_METRIC_CARDS_DATA: 'getPayMeTransactionsMetricCardsData',
  REFUND_TRANSACTION: 'refundTransaction',
  VOID_TRANSACTION: 'voidTransaction',
  CAPTURE_TRANSACTION: 'captureTransaction',
  SHARE_REPORT: 'SHARE_REPORT',
  HALAN_SUBMIT_OTP: 'halanSubmitOtp',
  // Orders related query keys
  GET_ORDERS: 'getOrders',
  GET_SINGLE_ORDER_DETAILS: 'getSingleOrderDetails',
  DELETE_ORDER: 'deleteOrder',
  // ChargeBacks related query keys
  GET_CHARGE_BACKS: 'getChargeBacks',
  GET_SINGLE_CHARGE_BACK_DETAILS: 'getSingleChargeBackDetails',
  // Quick Links related query keys
  GET_QUICK_LINKS: 'getQuickLinks',
  GET_SINGLE_QUICK_LINK: 'getSingleQuickLink',
  CANCEL_QUICK_LINK: 'cancelQuickLink',
  // PayMe related query keys
  GET_BRANCH_HANDLES: 'getBranchHandles',
  CREATE_BRANCH_HANDLE: 'createBranchHandle',
  UPDATE_BRANCH_HANDLE: 'updateBranchHandle',
  CHANGE_PAYMENT_HANDLE_STATUS: 'changePaymentHandleStatus',
  UPDATE_PAYMENT_HANDLE_SETTINGS: 'updatePaymentHandleSettings',
  GET_PAYMENT_HANDLE_CONFIG: 'getPaymentHandleConfig',
  GET_INTEGRATIONS_CURRENCIES: 'getIntegrationsCurrencies',
  // Reach related query keys
  REACH_GET_CURRENT_PLAN: 'reachGetCurrentPlan',
  REACH_GET_CAMPAIGNS: 'reachGetCampaigns',
  REACH_GET_SENDER_NAME: 'reachGetSenderName',
  REACH_GET_CAMPAIGN_STATICS: 'reachGetCampaignStatics',
  REACH_GET_CAMPAIGN_DETAILS: 'reachGetCampaignDetails',
  REACH_GET_CAMPAIGN_ANALYSIS: 'reachGetCampaignAnalysis',
  REACH_GET_BUNDLES: 'reachGetBundles',
  REACH_PORTAL_SSO: 'reachPortalSso',
  // Reports related query keys
  GET_REPORTS: 'getReports',
  GET_ARCHIVE_REPORTS: 'getArchiveReports',
  GET_STATEMENTS: 'getStatements',
  GET_DIGEST: 'getDigest',
  GET_REPORTS_FILTERS: 'getReportsFilters',
  GET_CUSTOM_REPORT_COLUMNS: 'getCustomReportColumns',
  GET_REPORT_TYPES: 'getReportTypes',
  EXPORT_REPORT: 'exportReport',
  // Risk Center related query keys
  GET_SUBSCRIPTION_DATA: 'getSubscriptionData',
  GET_SINGLE_RISK_ITEM_DETAILS: 'getSingleRiskItemDetails',
  GET_RISK_CENTER_DATA: 'getRiskCenterData',
  GET_RULES_MODAL_DATA: 'getRulesModalData',
  // Business Information related query keys
  GET_BUSINESS_INFORMATION: 'getBusinessInformation',
  GET_SECTOR_INDUSTRY: 'getSectorIndustry',
  // Terminals related query keys
  GET_TERMINALS: 'getTerminals',
  GET_BRANCHES: 'getBranches',
  CREATE_BRANCH: 'createBranch',
  GET_TERMINAL_STATISTICS: 'getTerminalStatistics',
  GET_TERMINAL_EXPORTS: 'getTerminalExports',
  // profile details related query keys
  GET_PROFILE_DETAILS: 'getProfileDetails',
  UPDATE_PROFILE_DETAILS: 'updateProfileDetails',
  CHANGE_PASSWORD: 'changePassword',
  // User Management related query keys
  GET_USERS: 'getUsers',
  GET_ROLES: 'getRoles',
  GET_ROLES_FROM_ID: 'getRolesFromId',
  GET_FILTER_ROLES: 'getFilterRoles',
  REMOVE_MEMBER: 'removeMember',
  CANCEL_INVITATION: 'cancelInvitation',
  CHANGE_ROLE: 'changeRole',
  INVITE_MEMBER: 'inviteMember',
  UPDATE_EXISTING_ROLE: 'updateExistingRole',
  RESEND_INVITE: 'resendInvite',
  GET_USER_EXISTING_PERMISSIONS: 'getUserExistingPermissions',
  GET_PERMS_CATALOG: 'getPermsCatalog',
  CREATE_NEW_ROLE: 'createNewRole',
  ROLE_DETAILS: 'roleDetails',
  ROLE_RETRIEVE: 'roleRetrieve',
  DELETE_ROLE: 'deleteRole',
  INVITATION_STATUS: 'invitationStatus',
  // notifications
  GET_FLAGS: 'getFlags',
  GET_EMAILS: 'getEmails',
  RESEND_OTP: 'resendOtp',
  // Customization related query keys
  CUSTOMIZATION_LISTING: "customizationListing",
  UPDATE_BUSINESS_LOGO: "submitBusinessLogo",
  RESET_BUSINESS_LOGO: "resetBusinessLogo",
  UPDATE_CUSTOMIZATION_DATA: "updateCustomizationData",
  RESET_CUSTOMIZATION_DATA: "resetCustomizationData",
  // Services related query keys
  Get_SERVICES: 'getServices',
  CHANGE_SUBSCRIPTION: 'changeSubscription',
  GET_MERCHANT_CLASS: 'getMerchantClass',
  CHANGE_INSTANT_SET: 'changeInstantSet',
  GET_SERVICES: 'getServices',
  // Payment Integrations related query keys
  GET_INTEGRATIONS: 'getIntegrations',
  GET_SINGLE_INTEGRATION_DETAILS: 'getSingleIntegrationDetails',
  UPDATE_MERCHANT_FLAGS: 'updateMerchantFlags',
  ADD_PAYMENT_INTEGRATION: 'addPaymentIntegration',
  GET_ALLOWED_INTEGRATIONS: 'getAllowedIntegrations',
  REFRESH_PAYPAL: 'refreshPaypal',
  // API Keys related query keys
  GET_API_KEY: 'getApiKey',
  GET_PUBLIC_SECRET_KEY: 'getPublicSecretKey',
  GET_HMAC: 'getHmacKey',
  // Iframes related query keys
  GET_IFRAMES: 'getIframes',
  ADD_IFRAME: 'addIframe',
  GET_PREVIEW: 'getPreview',
  DELETE_IFRAME: 'deleteIframe',
  CREATE_IFRAME: 'createIframe',
  DUPLICATE_IFRAME: 'duplicateIframe',
  EDIT_IFRAME: 'editIframe',
  // Xero related query keys
  GET_API_KEYS: 'getApiKeysXero',
  GET_XERO_ORGANIZATIONS: 'getXeroOrganizations',
  CONNECT_XERO_ORGANIZATION: 'connectXeroOrganization',
  DISCONNECT_XERO_ORGANIZATION: 'disconnectXeroOrganization',
  // Feedback related query keys
  SUBMIT_FEEDBACK: 'submitFeedback',
  // Switch related query keys
  OLD_DASHBOARD_USER_INFO: 'oldDashboardUserInfo',
  // Bulk payment links keys
  GET_MERCHANT_PAYMENT_METHODS: 'getMerchantPaymentMethods',
  GET_MERCHANT_PRESELECTED_METHODS: 'getMerchantPreselectedMethods',
  GET_MERCHANT_INTEGRATIONS_CURRENCIES: 'getMerchantIntegrationsCurrencies',
  CREATE_BULK_PAYMENT_LINK: 'createBulkPaymentLink',
  // Dashboard Guide
  UPDATE_DASHBOARD_GUIDE_STATUS: 'updateDashboardGuideStatus',
  // Bills key 
  GET_BILLS: 'getBills',
  GET_BILLS_HISTORY: "getBillsHistory",
  GET_BILLS_DISTRIBUTOR_HISTORY: "getBillsDistributorHistory",
  GET_SAVED_MERCHANTS: "getSavedMerchants",
  GET_MERCHANT_NAME: "getMerchantName",
  GET_WALLET_DATA: "getWalletData",
  GET_MAIN_DATA: "mainData",
  GET_AVAILABLE_BALANCE: "getAvailableBalance",
  GET_CATEGORY_SERVICES: 'getCategoryServices',
  CONFIRM_PAYMENT: 'confirmPayment',
  INQUIRY_PAYMENT: 'inquiryPayment',
  GET_SAVED_BILLS: "getSavedBills",
  GET_SINGLE_BILL_DETAILS: "getSingleBillDetails",
  GET_SAVED_BILLS_DETAILS: "getSavedBillsDetails",
  GET_TOP_UP_DETAILS: "getTopUpDetails",
  GET_BILLS_DETAILS: "getBillsDetails",
  GET_ADD_FUND_BALANCE_DETAILS: "getAddFundBalanceDetails",
  // pay ads 
  GET_ACCOUNT_DETAILS: "getAccountDetails",
  GET_BILLS_BALANCE: "getBillsBalance",
  // Disputes
  GET_DISPUTES: "getDisputes",
  GET_SINGLE_DISPUTE: "getSingleDispute",
  RESPOND_TO_DISPUTE: "respondToDispute",
  // Paymob Pro
  GET_PAYMOB_PRO_FREE_TRIAL: "getPaymobProFreeTrial",
  SHOW_PAYMOB_PRO_DRAWER: "showPaymobProDrawer",
};
